<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="detail-bg"></div>
    <div class="four-page">
      <div class="four-box">
        <div class="bg">
          404
          <div class="tip">{{ $t('krazenft') }}</div>
        </div>
      </div>
      <div class="tit">{{ $t('text24') }}</div>
      <div class="de">{{ $t('text25') }}</div>
      <el-button class="el-button--white block" @click="handleHome">
        {{ $t('text26') }}
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NoPage',
  components: {},
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    handleHome() {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
<style scoped lang="scss">
.four-page {
  .four-box {
    width: 2rem;
    height: 2.1rem;
    border-radius: 0.04rem;
    margin: 1.25rem auto 0.5rem;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.1),
      transparent
    );
    overflow: hidden;
    position: relative;
    .bg {
      width: 1.8rem;
      height: 1.84rem;
      margin: 0.08rem auto;
      background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.8),
        transparent
      );
      font-size: 0.48rem;
      font-weight: 700;
      font-family: 'Montserrat';
      text-align: center;
      line-height: 1.84rem;
      opacity: 0.38;
      .tip {
        font-size: 0.13rem;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        width: 0.8rem;
        text-align: center;
        margin-left: -0.4rem;
        text-transform: uppercase;
        font-weight: normal;
        line-height: 1;
      }
    }
  }
  .tit {
    color: #ffcf71;
    font-size: 0.24rem;
    font-family: 'Roboto Condensed';
    text-align: center;
    text-transform: uppercase;
  }
  .de {
    text-align: center;
    font-family: 'Montserrat';
    font-size: 0.12rem;
    margin: 0.1rem 0 0.3rem;
  }
  padding: 0 0.35rem;
}
</style>



// WEBPACK FOOTER //
// src/views/404.vue